import React from 'react'
import {connect} from 'react-redux'

import Text from '../../common/components/Text'
import { ButtonLink } from "buoy-core"

import * as actions from '../actions'
import AuthForm from './AuthForm'
import PageWrapper from './PageWrapper'

const Signup = (props) => (
  <AuthForm
    title="Create account."
    submitText="Submit"
    showEmail
    {...props}
  >
    <Text size="bodyMain">Already have an account? </Text>
    <ButtonLink onClick={props.onLoginClick}>Log in</ButtonLink>
  </AuthForm>
)

const SignupPage = PageWrapper(Signup)

const mapStateToProps = state => ({
  email: state.auth.email,
  authError: state.auth.status.signup
})

const mapDispatchToProps = dispatch => ({
  onLoginClick: () => window.location = '/login',
  onEmailChange: email => dispatch(actions.setEmail(email)),
  onSubmit: () => dispatch(actions.signup())
})

const SignupPageWrapper = connect(mapStateToProps, mapDispatchToProps)(SignupPage)

export {SignupPageWrapper as default, Signup}


// WEBPACK FOOTER //
// ./assets/auth/components/SignupPage.js